import LegalPage, { Section } from './LegalPage';

export default function PrivacyPage() {
  return (
    <LegalPage
      title="Privacy Notice (POPIA)"
      intro="This notice explains how My Bets, operated by Marome Investments (Pty) Ltd, collects and protects your personal information in line with the Protection of Personal Information Act (POPIA)."
    >
      <Section heading="What we collect">
        <p>As a licensed bookmaker we are required to verify who you are. We collect:</p>
        <ul className="list-disc space-y-1 pl-5">
          <li>Identity details — full legal name, date of birth, and ID or passport number.</li>
          <li>Contact details — email, mobile number and residential address.</li>
          <li>Optional details — province, occupation and source of funds.</li>
          <li>Account and betting activity — deposits, withdrawals, bets and balances.</li>
          <li>Technical data — device and log information needed to keep your account secure.</li>
        </ul>
      </Section>

      <Section heading="Your ID is hashed — never stored raw">
        <p>
          We do <strong className="text-text-primary">not</strong> store your raw ID or passport
          number. At registration your ID number is converted into a one-way SHA-256 hash, and only the
          hash is kept. The hash lets us prevent duplicate accounts and confirm verification without
          ever holding the raw government ID. The original number cannot be recovered from the hash.
        </p>
      </Section>

      <Section heading="Why we collect it">
        <ul className="list-disc space-y-1 pl-5">
          <li>To verify your identity and age (18+) as required by law (FICA/KYC).</li>
          <li>To operate your account, process bets, deposits and withdrawals.</li>
          <li>To prevent fraud, money laundering and underage gambling.</li>
          <li>To provide responsible-gambling tools and support.</li>
          <li>To send marketing only where you have opted in (you can opt out anytime).</li>
        </ul>
      </Section>

      <Section heading="How we protect it">
        <p>
          We use appropriate technical and organisational safeguards, encrypt sensitive data in transit,
          and limit access to staff who need it. Payments are handled by a PCI-DSS compliant provider.
        </p>
      </Section>

      <Section heading="Retention">
        <p>
          We keep your information for as long as your account is active and for the period afterwards
          required by gambling, financial and anti-money-laundering laws. When no longer required, data
          is securely deleted or anonymised.
        </p>
      </Section>

      <Section heading="Your rights">
        <p>
          Under POPIA you may request access to your personal information, ask us to correct it, or
          object to certain processing. To exercise these rights or raise a privacy concern, contact our
          support team.
        </p>
      </Section>
    </LegalPage>
  );
}
